const FontSize = {
    xxs: 0.625,
    xs: 0.75,
    s: 0.81,
    sm: 0.875,
    m: 1,
    md: 1.125,
    l: 1.5,
    xl: 1.75,
    xxl: 2.25,
    xxxl: 3, //48px
};

export { FontSize as default };
//# sourceMappingURL=fontSize.js.map
